
























































import { ThemeConfig } from "@/model/config/ThemeConfig";
import { Component, Vue } from "vue-property-decorator";
import { mapGetters, mapState } from "vuex";
import { themeBg } from "@/assets/themeBg";

@Component({
  computed: {
    ...mapGetters('themeModule', ['themeConfig']),
    ...mapState(['linkDownloadApp', 'linkSettings']),
    },
})
export default class DownloadApp extends Vue {
  themeConfig!: ThemeConfig;
  linkDownloadApp!: string;
  linkSettings!: string;

  get bgImg(): string | null {
    return themeBg['resource-supply'];
  }

  get theme() {
    const theme: Record<string, string | null> = {bgImg: null, topLeftLogo: null, topCenterLogo: null, topRightLogo: null, formLogo: null};

    if ( !this.themeConfig.themeName ) return theme;

    theme.bgImg = themeBg[this.themeConfig.themeName || "water"];

    theme.topCenterLogo = `/themes/${this.themeConfig.themeName}/login-page-top-logo.svg`;
    if ( this.themeConfig.showLoginPageSideLogo ) {
      theme.topLeftLogo = `/themes/${this.themeConfig.themeName}/login-page-top-left-logo.svg`;
      theme.topRightLogo = `/themes/${this.themeConfig.themeName}/login-page-top-right-logo.svg`;
    }

    return theme;
  }

  get copyrightYears() {
    const yearForm = this.themeConfig.copyrightYearFrom || 2020;
    const currentYear = new Date().getFullYear();
    if (currentYear > yearForm) {
      return `${yearForm} - ${currentYear}`;
    }
    return `${currentYear}`;
  }

  get copyrightText() {
    return this.themeConfig.copyrightText ?? '©<br>АО «Росатом Инфраструктурные решения»';
  }

  getCopyrightText() {
    return `${this.copyrightYears} ${this.copyrightText}`;
  }

  toDownloadLink() {
    window.open(this.linkDownloadApp, '_blank');
  }

  toSettings() {
    window.open(this.linkSettings, '_blank');
  }
}
